var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmatphoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3096_7223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66637 1.32104H3.18626C2.80185 1.32104 2.49023 1.63266 2.49023 2.01707V7.58525C2.49023 7.96965 2.80185 8.28127 3.18626 8.28127H6.66637C7.05077 8.28127 7.36239 7.96965 7.36239 7.58525V2.01707C7.36239 1.63266 7.05077 1.32104 6.66637 1.32104Z",
    stroke: "#6A7282",
    strokeWidth: 0.696023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92627 6.88916H4.93065",
    stroke: "#6A7282",
    strokeWidth: 0.696023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3096_7223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 8.75,
    fill: "white",
    transform: "translate(0.75 0.625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmatphoneIcon);
export default __webpack_public_path__ + "static/media/smatphone-icon.3f271702b66a2809c4799a1516f1308d.svg";
export { ForwardRef as ReactComponent };